import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Avatar from "features/shared/components/avatar/Avatar";
import Card from "features/shared/components/card/Card";
import AddressFormatter from "features/shared/components/formatters/AddressFormatter";
import AddressDTO from "features/shared/dtos/AddressDTO";
import React from "react";
import { CustomerType } from "features/customer/enums/customerType";
import SubjectInfo from "./SubjectInfo";
import CompanyDTO from "features/customer//dtos/CompanyDTO";
import Person from "features/customer//dtos/PersonDTO";
import styles from './subjectInfoCard.module.scss';
import { useTranslation } from "react-i18next";

type Props = {
  subjectName: string;
  subjectType: CustomerType;
  subjectTypeIcon: IconProp;
  subjectAddress: AddressDTO;
  company?: CompanyDTO;
  person?: Person;
  subjectNumber?: string;
  renderOtherInfo?: () => JSX.Element;
  className?: string;
};

const SubjectInfoCard = ({
  subjectName,
  subjectType,
  subjectTypeIcon,
  subjectAddress,
  person,
  company,
  subjectNumber,
  renderOtherInfo,
  className
}: Props) => {
  // translations
  const tLabels = useTranslation("customer\\customer").t;

  // sub-renders
  const renderSubjectNumber = () => { 
    if (subjectNumber) {
      return (
        <>
          <div className="w-100 d-lg-none"></div>
          <span
            className={`badge badge-pill mt-n1 font-weight-normal ${styles.customerNumber}`}
            title={subjectNumber}
          >
            {subjectNumber}
          </span>
        </>
      );
    }
  }

  // render
  return (
    <Card className={`${styles.subjectCard}${className ? " " + className : ""}`}>
      <div className="row no-gutters">
        <div className="d-flex d-sm-block justify-content-center col-sm-auto pr-sm-4">
          <Avatar icon={subjectTypeIcon} size={80} iconSize={2} />
        </div>
        <div className="col-sm">
          <div className="row no-gutters">
            <div className="col-sm pr-sm-3 pr-lg-5 text-center text-sm-left">
              <div className="my-2">
                <h5 className="mt-3 mt-sm-0 mb-0">
                  <span className="mr-2">{subjectName}</span>
                  {renderSubjectNumber()}
                </h5>
              </div>
              <SubjectInfo
                type={subjectType}
                person={person}
                company={company}
              />
            </div>
            <div className="col-sm pl-sm-4 pl-lg-5">
              <hr className="d-sm-none" />
              <div className="d-flex flex-wrap flex-sm-column flex-lg-row mt-2">
                <span className="mr-3 text-muted">{tLabels("subjectInfoCard.address")}</span>
                <AddressFormatter address={subjectAddress} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {renderOtherInfo && 
        renderOtherInfo()
      }
    </Card>
  );
};

export default SubjectInfoCard;
